import React from 'react';

const GlobalFooter = () => {
  return (
    <footer className="bg-gray-100 border-t border-brand-border mt-auto no-print">
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <img
            src="/images/logo-dark-compact.png"
            alt=""
            className="h-5 w-auto opacity-60"
          />
          <span className="text-brand-muted text-sm">
            Nordic Agent Portal &middot; Kirseb&aelig;rkroen
          </span>
        </div>
        <span className="text-brand-muted/60 text-xs">
          &copy; {new Date().getFullYear()}
        </span>
      </div>
    </footer>
  );
};

export default GlobalFooter;
